export const batteryTooltipFormatter = (value, name, item) =>
    item?.dataKey === 'batt' ? [`${value}%`, name] : [value, name]
